import { Record, List } from 'immutable';

const defaultValues = {
  currentDesignPageIndex: 0,
  isSwitchFromCC: true,
  progressSourceFrom: null,
};

export default class DesignParameter extends Record(defaultValues, DesignParameter) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const DesignParameters = (data) => {
  let parameters = new List();
  if (data) {
    data.forEach((value) => {
      parameters = parameters.push(new DesignParameter(value));
    });
  }
  return parameters;
};

export const initialState = {
  loading: false,
  errorMessage: null,
  data: new DesignParameter(),
  hasUpdated: false,
  isExisting: false,
}

export const DesignParameterState = Record({ ...initialState });
